
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plan-groups",
      function () {
        return require("private-next-pages/plan-groups/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plan-groups"])
      });
    }
  